import AntBackTop from 'antd/lib/back-top';
import css from './backtop.module.scss';

export default function BackTop({ children, ...rest }: any) {
    const classList = [css.efBacktop];
    const props = { ...rest };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }
    return <AntBackTop {...props}>{children && children()}</AntBackTop>;
}
